import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useLocation } from "react-router-dom";
import logo from './assets/vibrant_icon.png';
const Navbar = () => {
/*  useEffect(() => {
    const handleStorageChange = () => {
      const access = localStorage.getItem("screenAccess");
      if (access) setScreenAccess(access.split(","));
    };
  
    window.addEventListener("storage", handleStorageChange);
    handleStorageChange(); // for initial load
  
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);*/
  

  const navigate = useNavigate();
  const location = useLocation();

  const [anchorAdmin, setAnchorAdmin] = useState(null);
  const [anchorOperations, setAnchorOperations] = useState(null);
  const [screenAccess, setScreenAccess] = useState([]);

  const isLoginPage = location.pathname === "/";

/*  useEffect(() => {
    const access = localStorage.getItem("screenAccess");
    if (access) {
      setScreenAccess(access.split(","));
    }
  }, []);*/
  useEffect(() => {
    const updateAccess = () => {
      const access = localStorage.getItem("screenAccess");
      setScreenAccess(access ? access.split(",") : []);
    };
  
    window.addEventListener("screenAccessUpdated", updateAccess);
    updateAccess(); // initial load
  
    return () => window.removeEventListener("screenAccessUpdated", updateAccess);
  }, []);
  

  const hasAccess = (screenId) => screenAccess.includes(screenId);

  const handleMenuOpen = (event, type) => {
    if (type === "admin") setAnchorAdmin(event.currentTarget);
    else setAnchorOperations(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorAdmin(null);
    setAnchorOperations(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const showAdminMenu = ["ADM-001", "ADM-002", "ADM-003"].some(hasAccess);
  const showOpsMenu = ["OPR-001", "OPR-002", "OPR-003", "OPR-004", "OPR-005","OPR-006","OPR-007","OPR-008","OPR-009","OPR-010","OPR-011","OPR-012","OPR-013","OPR-014"].some(hasAccess);

  return (
    <AppBar position="static">
      <Toolbar>
      <img
        src={logo}
        alt="Logo"
        style={{ height: 40, marginRight: 16 }}
      />
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Vibrant Verification
  </Typography> 

        {!isLoginPage && (
          <>
            {showAdminMenu && (
              <>
                <Button color="inherit" onClick={(e) => handleMenuOpen(e, "admin")}>
                  Administration
                </Button>
                <Menu anchorEl={anchorAdmin} open={Boolean(anchorAdmin)} onClose={handleMenuClose}>
                  {hasAccess("ADM-001") && (
                    <MenuItem onClick={() => {handleMenuClose(); navigate("/roles")}}>Roles</MenuItem>
                  )}
                  {hasAccess("ADM-002") && (
                    <MenuItem onClick={() => {handleMenuClose(); navigate("/users")}}>Users</MenuItem>
                  )}
                  {hasAccess("ADM-003") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/generatepassword")}}>Generate Password</MenuItem>
                  )}
                </Menu>
              </>
            )}

            {showOpsMenu && (
              <>
                <Button color="inherit" onClick={(e) => handleMenuOpen(e, "operations")}>
                  Operations
                </Button>
                <Menu anchorEl={anchorOperations} open={Boolean(anchorOperations)} onClose={handleMenuClose}>
                  {hasAccess("OPR-001") && (
                    <MenuItem onClick={() =>{handleMenuClose(); navigate("/uploadaddresscheckone")}}>Upload Address Check 1 -Old</MenuItem>
                  )}
                  {hasAccess("OPR-006") && (
                    <MenuItem onClick={() =>{handleMenuClose(); navigate("/uploadchecks")}}>Upload Checks - New</MenuItem>
                  )}                  
                  {hasAccess("OPR-002") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/manualallocatetofetl")}}>Manual Allocation To TL-FE - Old</MenuItem>
                  )}
                  {hasAccess("OPR-007") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/manuallyallocatecheckstofetl")}}>Manual Allocation Of Checks To TL-FE - New</MenuItem>
                  )}                  
                  {hasAccess("OPR-003") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/manualallocatetofe")}}>Manual Allocation To FE - Old</MenuItem>
                  )}
                  {hasAccess("OPR-008") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/manuallyallocatecheckstofe")}}>Manual Allocation of Checks To FE - New</MenuItem>
                  )}                  
                  {hasAccess("OPR-009") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/meetings")}}>Meetings</MenuItem>
                  )}   
                  {hasAccess("OPR-010") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/manuallyallocatecheckstofenew")}}>Download And Allocate to FE TL</MenuItem>
                  )}                                    
                  {hasAccess("OPR-011") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/meetingrequests")}}>Meeting Requests</MenuItem>
                  )}                                                      
                  {hasAccess("OPR-012") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/bankverificationimport")}}>Bank Verification Import</MenuItem>
                  )}                  
                  {hasAccess("OPR-013") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/bankverificationallocationtoassociate")}}>Bank Verification - Allocation to Associate</MenuItem>
                  )}                                                                        
                  {hasAccess("OPR-014") && (
                    <MenuItem onClick={() => {handleMenuClose();navigate("/bankverificationallocatedtoassociate")}}>Bank Verification - Allocated to Associate</MenuItem>
                  )}                                                                                          
                </Menu>
              </>
            )}

            {/* 👇 Sign Out Button with Icon */}
            <Tooltip title="Sign Out">
              <IconButton color="inherit" onClick={handleLogout}>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
